import React, { ReactNode } from 'react';

const Card = ({ children, className }: Props) => {
  return (
    <div className={`card h-100 ${className}`}>
      {children}
    </div>
  );
}

interface Props {
  children: ReactNode,
  className?: string
}

export { Card };